import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { ASSIGN_COACH, ASSIGN_COACH_ERROR, ASSIGN_COACH_SUCCESS } from '../../../actions.js';

function* assignCoach({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/assign-coach`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.body,
      },
    });

    if (response.status === 200) {
      if (response?.data?.code == 4089) cogoToast.warn(response?.data?.message);
      else cogoToast.success(response?.data?.message);
      yield put({
        type: ASSIGN_COACH_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: ASSIGN_COACH_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: ASSIGN_COACH_ERROR, payload: error });
  }
}

export function* watchAssignCoach() {
  yield takeEvery(ASSIGN_COACH, assignCoach);
}

function* assignCoachSaga() {
  yield all([fork(watchAssignCoach)]);
}

export default assignCoachSaga;
